module.exports = __webpack_public_path__ + "img/logo-eosc-synergy-o.f516d2e7.png";